<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4>{{title | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="main">
        <gdp-add-edit-flag-form [loading]="loading" [flag]="flag" [flags]="flags" (onSubmit)="onSubmit($event)"></gdp-add-edit-flag-form>
      </div>
    </div>
  </div>
</div>